import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { responsive } from "../../utils/responsive";

export const galleryStyle = recipe({
  base: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacings.s,
    ...responsive({
      s: {
        gridTemplateColumns: "repeat(4, 1fr)",
      },
    }),
  },
});

export const itemStyle = style({
  aspectRatio: "1",
  selectors: {
    "&:last-child": {
      display: "none",
      ...responsive({
        s: {
          display: "block",
        },
      }),
    },
  },
});

export const featuredItemStyle = style({
  gridColumn: "span 1",
  gridRow: "span 1",
  ...responsive({
    s: {
      gridColumn: "span 2",
      gridRow: "span 2",
    },
  }),
});
